/** @jsx jsx */
import { jsx, keyframes } from '@emotion/core'
const loader = keyframes`
           from { transform: rotate(0deg)}
           to { transform: rotate(360deg)}
`
function CircularProgress(props) {
  const { height = '10px', width = '10px', borderTopColor = '#fff', borderWidth = '1px' } = props
  return (
    props.show ?
      <span
        css={{
          display: 'inline-block',
          height: height,
          width: width,
          borderRadius: '50%',
          border: `${borderWidth} solid #959595`,
          borderTop: `${borderWidth} solid ${borderTopColor}`,
          animation: `${loader} 0.7s infinite linear`
        }}
      /> :
      null
  )
}

export default CircularProgress
